import { ISession } from '@core/state/entities/session/session.entity';
import { defaultEntityState } from '@core/state/entities/entity';
import {
  mergeEntityState,
  normalizeAndMergeEntity,
  normalizeAndRemoveEntities,
  removeEntitiesWithIds,
} from '@core/state/entities/entity.helpers';
import {
  incompleteStudiesPayloadSchema,
  stageActions,
  stageStudyActions,
} from '@core/actions/stage.actions';
import { studyOutgoingDtoSchema } from '@core/services/stage/review-effects';
import { studiesActions } from '@core/actions/studies.actions';
import { projectStudyIncomingDtoSchema } from '@core/services/study-table/study-table.effects';
import { SessionStatus } from '@core/services/api-client.generated';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '@core/state/entities/entity-name-map';

export const sessionEntityReducer = createReducer(
  defaultEntityState<ISession>(),
  on(studiesActions.studyListUpdated, (state, props) =>
    normalizeAndMergeEntity(
      entityKey.sessions,
      state,
      props,
      projectStudyIncomingDtoSchema
    )
  ),
  on(stageActions.receivedInProgressStudies, (state, props) =>
    mergeEntityState(entityKey.sessions, state, props)
  ),
  on(stageActions.incompleteSessionsUpdated, (state, props) =>
    normalizeAndMergeEntity(
      entityKey.sessions,
      state,
      props,
      incompleteStudiesPayloadSchema,
      (sess) =>
        sess.investigatorId === props.investigatorId &&
        sess.stageId === props.stageId &&
        sess.status === SessionStatus.Incomplete &&
        sess.studyId !== props.currentStudyId
    )
  ),
  on(
    stageActions.updateSession,
    stageActions.sessionSaved,
    stageStudyActions.receivedStageStudy,
    (state, props) => mergeEntityState(entityKey.sessions, state, props)
  ),
  on(stageActions.saveSession, (state, props) =>
    props.correlationId !== undefined
      ? state
      : normalizeAndMergeEntity(
          entityKey.sessions,
          state,
          props,
          studyOutgoingDtoSchema
        )
  ),
  on(stageActions.deleteSession, (state, props) =>
    props.correlationId !== undefined
      ? state
      : normalizeAndRemoveEntities(
          entityKey.sessions,
          state,
          props,
          studyOutgoingDtoSchema
        )
  ),
  on(stageActions.commitSessionDeletion, (state, props) =>
    removeEntitiesWithIds(state, [props.session.id])
  )
);
